import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { subscribeToMessages, updateLastSeenChat } from "../api/firebase/firebaseChat";

import { useProfileData } from "../../../hooks/useProfileData";

import { Chat, Message } from "../types";

export const useGetChatMessages = (chats?: Chat[]) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [isMessagesLoading, setIsMessagesLoading] = useState(false);
  const { chatId } = useParams();
  const { data } = useProfileData();
  const userId = data.id;

  useEffect(() => {
    if (!chatId || !userId) return;
    updateLastSeenChat(chatId, userId);
  }, [chatId, userId]);

  useEffect(() => {
    if (!chatId) return;
    setIsMessagesLoading(true);

    const unsubscribe = subscribeToMessages(chatId, (msgs) => {
      setMessages(msgs);
      setIsMessagesLoading(false);
    });

    return () => unsubscribe();
  }, [chatId]);

  return {
    messages,
    isMessagesLoading,
  };
};
